// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeBanner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 4.4rem;
  padding: 0.6rem 1.6rem;
  box-sizing: border-box;
  background-color: #ffffff;
  color: #f59e0b;
  text-decoration: underline;
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 1.8rem;
  text-align: center;
  cursor: pointer;
  position: relative;
  z-index: 3;
}
.HomeBanner, .HomeBanner:visited, .HomeBanner:hover, .HomeBanner:active {
  color: #f59e0b;
}
.HomeBanner:focus-visible {
  outline: 0.2rem solid #00aa74;
  outline-offset: -0.2rem;
}
.HomeBanner__text {
  display: inline-block;
  max-width: 100%;
  word-break: break-word;
}
@media (prefers-reduced-motion: reduce) {
  .HomeBanner {
    transition: none;
    animation: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Layout/HomeBanner/style.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AACJ;AACI;EAII,cAAA;AAFR;AAKI;EACI,6BAAA;EACA,uBAAA;AAHR;AAMI;EACI,qBAAA;EACA,eAAA;EACA,sBAAA;AAJR;AAOI;EArCJ;IAsCQ,gBAAA;IACA,eAAA;EAJN;AACF","sourcesContent":[".HomeBanner {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    min-height: 4.4rem;\n    padding: 0.6rem 1.6rem;\n    box-sizing: border-box;\n    background-color: #ffffff;\n    color: #f59e0b;\n    text-decoration: underline;\n    font-size: 1.4rem;\n    font-weight: 600;\n    line-height: 1.8rem;\n    text-align: center;\n    cursor: pointer;\n    position: relative;\n    z-index: 3;\n\n    &,\n    &:visited,\n    &:hover,\n    &:active {\n        color: #f59e0b;\n    }\n\n    &:focus-visible {\n        outline: 0.2rem solid #00aa74;\n        outline-offset: -0.2rem;\n    }\n\n    &__text {\n        display: inline-block;\n        max-width: 100%;\n        word-break: break-word;\n    }\n\n    @media (prefers-reduced-motion: reduce) {\n        transition: none;\n        animation: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
